<template>
    <div id="viettel-login-page">
        <el-container>
            <div id="viettel-login-container" class="w-100 d-flex justify-content-center" style="height: 100vh;">
                <el-row type="flex" class="row-bg w-100" justify="center" align="middle">
                    <el-main>
                        <!--                        <el-card v-if="loginMode == 'DEFAULT'"-->
                        <!--                            class="login-box-card box-card d-flex justify-content-center" body-style="width: 100%">-->
                        <!--                            <div class="d-flex justify-content-center" id="login-page-logo">-->
                        <!--                                <el-image style="width: 30%;" :src="require('@/assets/images/login/logo_vmail.svg')" :fit="fit"></el-image>-->
                        <!--                            </div>-->

                        <!--                            <el-row>-->
                        <!--                                <p id="login-option-label">-->
                        <!--                                    Choose your login account-->
                        <!--                                </p>-->
                        <!--                            </el-row>-->

                        <!--                            <el-row :gutter="30">-->
                        <!--                                <el-col :span="10" :offset="2">-->
                        <!--                                    <el-card shadow="hover" class="login-option" id="login-option-guest"-->
                        <!--                                        @click.native="routeToGuestPage">-->
                        <!--                                        <svg class="login-type-icon" width="52" height="52" viewBox="0 0 52 52"-->
                        <!--                                            xmlns="http://www.w3.org/2000/svg">-->
                        <!--                                            <path-->
                        <!--                                                d="M25.9922 5.2C29.7362 5.2 32.9238 7.826 33.6466 11.4452C33.6867 11.615 33.6922 11.7912 33.6628 11.9631C33.6333 12.1351 33.5696 12.2994 33.4753 12.4463C33.381 12.5931 33.2582 12.7194 33.114 12.8178C32.9699 12.9161 32.8074 12.9844 32.6363 13.0186C32.4653 13.0528 32.289 13.0523 32.1182 13.0169C31.9473 12.9816 31.7853 12.9122 31.6418 12.813C31.4983 12.7137 31.3762 12.5865 31.2829 12.4391C31.1896 12.2917 31.1269 12.127 31.0986 11.9548C30.8597 10.7779 30.2197 9.72037 29.288 8.96267C28.3563 8.20497 27.1905 7.79404 25.9896 7.8C23.2466 7.8 20.9976 9.9242 20.8 12.6178L20.7844 13.0078V18.2H36.4C37.7791 18.2 39.1018 18.7479 40.077 19.723C41.0522 20.6982 41.6 22.0209 41.6 23.4V41.6C41.6 42.9791 41.0522 44.3018 40.077 45.277C39.1018 46.2521 37.7791 46.8 36.4 46.8H15.6C14.2209 46.8 12.8983 46.2521 11.9231 45.277C10.9479 44.3018 10.4 42.9791 10.4 41.6V23.4C10.4 22.0209 10.9479 20.6982 11.9231 19.723C12.8983 18.7479 14.2209 18.2 15.6 18.2H18.187V13.0052C18.187 10.9351 19.0094 8.94985 20.4731 7.48609C21.9369 6.02233 23.9222 5.2 25.9922 5.2V5.2ZM36.4 20.8H15.6C14.9105 20.8 14.2491 21.0739 13.7615 21.5615C13.274 22.0491 13 22.7104 13 23.4V41.6C13 42.2896 13.274 42.9509 13.7615 43.4385C14.2491 43.9261 14.9105 44.2 15.6 44.2H36.4C37.0896 44.2 37.7509 43.9261 38.2385 43.4385C38.7261 42.9509 39 42.2896 39 41.6V23.4C39 22.7104 38.7261 22.0491 38.2385 21.5615C37.7509 21.0739 37.0896 20.8 36.4 20.8ZM26 29.9C26.6896 29.9 27.3509 30.1739 27.8385 30.6615C28.3261 31.1491 28.6 31.8104 28.6 32.5C28.6 33.1896 28.3261 33.8509 27.8385 34.3385C27.3509 34.8261 26.6896 35.1 26 35.1C25.3105 35.1 24.6491 34.8261 24.1615 34.3385C23.674 33.8509 23.4 33.1896 23.4 32.5C23.4 31.8104 23.674 31.1491 24.1615 30.6615C24.6491 30.1739 25.3105 29.9 26 29.9V29.9Z" />-->
                        <!--                                        </svg>-->

                        <!--                                        <p class="login-type-name">Guest</p>-->
                        <!--                                    </el-card>-->
                        <!--                                </el-col>-->
                        <!--                                <el-col :span="10">-->
                        <!--                                    <el-card shadow="hover" class="login-option" id="login-option-sso">-->
                        <!--                                        <svg class="login-type-icon" width="52" height="52" viewBox="0 0 52 52"-->
                        <!--                                            xmlns="http://www.w3.org/2000/svg">-->
                        <!--                                            <path-->
                        <!--                                                d="M25.2798 5.4184C25.4931 5.27642 25.7437 5.20067 26 5.20067C26.2563 5.20067 26.5068 5.27642 26.7202 5.4184C31.6286 8.7274 37.2239 10.8796 43.0846 11.713C43.3942 11.7574 43.6775 11.912 43.8824 12.1484C44.0873 12.3848 44.2 12.6872 44.2 13V24.2866C43.5327 23.2829 42.643 22.4466 41.6 21.8426V14.1128C36.4493 13.2404 31.5096 11.4039 27.04 8.6996L26 8.0522L24.96 8.6996C20.4904 11.4039 15.5506 13.2404 10.4 14.1128V24.7C10.4 33.5192 15.5168 39.9438 26 44.1038V44.2C26 45.0892 26.2236 45.9238 26.6162 46.657L26.468 46.7142C26.1668 46.8304 25.8332 46.8304 25.532 46.7142C13.8008 42.198 7.79999 34.814 7.79999 24.7V13C7.80004 12.6868 7.91317 12.3841 8.11857 12.1477C8.32398 11.9112 8.60786 11.7568 8.91799 11.713C14.7778 10.8792 20.3721 8.72704 25.2798 5.4184V5.4184ZM32.5 31.2V28.6C32.5 27.2209 33.0478 25.8982 34.023 24.923C34.9982 23.9479 36.3209 23.4 37.7 23.4C39.0791 23.4 40.4018 23.9479 41.3769 24.923C42.3521 25.8982 42.9 27.2209 42.9 28.6V31.2H44.2C44.8895 31.2 45.5509 31.4739 46.0385 31.9615C46.5261 32.4491 46.8 33.1104 46.8 33.8V44.2C46.8 44.8896 46.5261 45.5509 46.0385 46.0385C45.5509 46.5261 44.8895 46.8 44.2 46.8H31.2C30.5104 46.8 29.8491 46.5261 29.3615 46.0385C28.8739 45.5509 28.6 44.8896 28.6 44.2V33.8C28.6 33.1104 28.8739 32.4491 29.3615 31.9615C29.8491 31.4739 30.5104 31.2 31.2 31.2H32.5ZM35.1 28.6V31.2H40.3V28.6C40.3 27.9104 40.0261 27.2491 39.5385 26.7615C39.0509 26.2739 38.3895 26 37.7 26C37.0104 26 36.3491 26.2739 35.8615 26.7615C35.3739 27.2491 35.1 27.9104 35.1 28.6ZM39.65 39C39.65 38.4828 39.4445 37.9868 39.0788 37.6211C38.7131 37.2554 38.2172 37.05 37.7 37.05C37.1828 37.05 36.6868 37.2554 36.3211 37.6211C35.9554 37.9868 35.75 38.4828 35.75 39C35.75 39.5172 35.9554 40.0132 36.3211 40.3789C36.6868 40.7445 37.1828 40.95 37.7 40.95C38.2172 40.95 38.7131 40.7445 39.0788 40.3789C39.4445 40.0132 39.65 39.5172 39.65 39Z" />-->
                        <!--                                        </svg>-->

                        <!--                                        <p class="login-type-name">Viettel SSO</p>-->
                        <!--                                    </el-card>-->
                        <!--                                </el-col>-->
                        <!--                            </el-row>-->
                        <!--                        </el-card>-->

                        <div v-if="loginMode == 'GUEST'">
                            <el-card class="login-box-card guest box-card d-flex justify-content-center"
                                body-style="width: 100%">
                                <!-- Form đăng nhập -->
                                <div class="d-flex justify-content-center" id="login-page-logo">
                                    <!--                                    <el-image style="width: 40%;" :src="require('@/assets/images/login/logo_vmail.svg')" :fit="fit"></el-image>-->
                                    <el-image style="width: 40%;"
                                        :src="require('@/assets/images/login/logo_vmail.svg')"></el-image>
                                </div>
                                <el-form v-if="loginMode === 'GUEST'" :model="data" ref="data" class="login-form-guest"
                                    label-width="120px" :label-position="labelPosition">
                                    <el-form-item :label="$t('zimbraNokey.zimbra_login_username')"
                                        class="label-input100">
                                        <div class="border-bottom-custom" :class="{ 'isUserFocused': isUserFocused }">
                                            <el-input v-model="data.username"
                                                :placeholder="$t('zimbraNokey.zimbra_login_username')"
                                                @focus="handleFocus" @blur="handleBlur">
                                                <template #prepend>
                                                    <i class="fas fa-user"
                                                        :class="{ 'focus-input': isUserFocused }"></i>
                                                </template>
                                            </el-input>
                                        </div>
                                    </el-form-item>
                                    <el-form-item :label="$t('zimbraNokey.zimbra_login_password')">
                                        <div class="border-bottom-custom" :class="{ 'isPassFocused': isPassFocused }">
                                            <el-input :type="showPassword ? 'text' : 'password'" v-model="data.password"
                                                :placeholder="$t('zimbraNokey.zimbra_login_password')"
                                                @focus="handlePassWordFocus" @blur="handlePassWordBlur">
                                                <template #prepend>
                                                    <i style="cursor: pointer;" @click="togglePasswordVisibility"
                                                        :class="{
                                                            'fas fa-eye': showPassword,
                                                            'fas fa-eye-slash': !showPassword,
                                                            'focus-input': isPassFocused
                                                        }"></i>
                                                </template>
                                            </el-input>
                                        </div>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button id="login-guest-btn" type="primary" :loading="isLoggingIn"
                                            @click="handleLoginGuest" :disabled="disableButton">Login
                                        </el-button>
                                        <!-- <el-button id="login-guest-fgpw" type="text">Forgot password</el-button> -->
                                    </el-form-item>
                                </el-form>

                                <div v-if="authFailed" class="error-login">
                                    {{ $t("zimbraNokey.zimbra_login_authFailed") }}
                                    <a href="javascript:;" class="close-error"><i class="fal fa-times"
                                            @click="hiddenError"></i></a>
                                </div>
                            </el-card>
                            <br>
                            <LoginSSO v-if="showSSO"></LoginSSO>

                            <div class="login-copy-writer">
                                <p>© 2024 Phát triển bởi Trung tâm Công nghệ Thông tin Viettel</p>
                                <p>Bản quyền thuộc Tập đoàn Công nghiệp - Viễn thông Quân đội Viettel</p>
                                <p>Hỗ trợ: 1789 nhánh 2 / Email: hotro_cntt@viettel.com.vn</p>
                            </div>
                        </div>

                    </el-main>
                </el-row>
            </div>


        </el-container>
    </div>
</template>
<style>
.el-form--label-left .el-form-item__label {
    font-family: FS PFBeauSansPro-Light, sans-serif;
    font-size: 14px;
    color: #000;
    font-weight: 600 !important;
}

.el-input-group__prepend {
    border: none !important;
    background: transparent;
}

.el-input__inner {
    border: none;
}

.border-bottom-custom {
    border-bottom: 2px solid #d9d9d9;
    transition: border-color 0.5s ease;
    /* Hiệu ứng chuyển màu mượt mà */
}

.isUserFocused,
.isPassFocused {
    border-bottom: 2px solid #e73d63;
}

.focus-input {
    color: #EE0033;
    transition: border-color 0.5s ease;
}

.el-form-item__content .el-input-group {
    height: 45px;
}

.el-input-group__prepend {
    padding-right: 0px;
    padding-left: 10px;
}

.el-input__inner {
    height: 100%;
}

@media screen and (max-width: 768px) {
    #viettel-login-container .login-box-card.guest {
        width: 95%;
    }
}

.login-copy-writer {
    position: absolute;
    bottom: 1em;
    font-size: .8vw;
    font-weight: 400;
    color: #fff;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
}
</style>
<script>

import AccountService from "@/services/account/AccountService";
import CommonUtils from "@/utils/common-utils";
import { ERROR_CODE } from "@/utils/constants";
import { mapActions } from "vuex";
import LoginSSO from "./LoginSSO.vue";
import NetworkService from "@/services/NetworkService";

export default {

    name: "ViettelLogin",
    data() {
        return {
            loginMode: "DEFAULT",
            labelPosition: "left",
            data: {
                username: "",
                password: "",
                virtualHost: this.$configZimbra.VIRTUAL_HOST
            },
            authFailed: false,
            showPassword: false,
            isLoggingIn: false,
            isUserFocused: false,
            isPassFocused: false,
            isPrivateNetwork: false,
        };
    },
    components: {
        LoginSSO
    },
    mixins: [CommonUtils],

    async created() {
        this.loginMode = "GUEST";
        this.removeLocalStorage("token_sso");
        var authToken = this.getLocalStorageObject("zimbra_token");
        if (authToken != null) {
            this.removeLocalStorage("zimbra_token");
        }
        this.clearSiteData();
        this.deleteAllCookies();
        this.removeLocalStorage("CONFIG_AVATAR");
        this.removeLocalStorage("data_compose");
        localStorage.clear();
        // if(window.location.hostname.includes('vmail.viettel.vn')){
        //     const URL = (this.isPrivateNetwork ? this.$configZimbra.ENDPOINT.ssoAddressPrivate :
        //         this.$configZimbra.ENDPOINT.ssoAddress ) + '/login?service=';
        //     const serviceUrl = this.$configZimbra.CLIENT_ADDRESS + '/auth-sso';
        //     window.location.href = URL + encodeURIComponent(serviceUrl) + '&appCode=' + encodeURIComponent(this.$configZimbra.APP_CODE);
        // }
    },
    computed: {
        disableButton() {
            return !(this.data.username.length >= 3 && this.data.password.length >= 8);
        },
        showSSO(){
            return process.env['VUE_APP_SSO_REDIRECT '] == 'true';
        }
    },

    mounted() {
        window.addEventListener('keydown', (event) => {
            if (event.key == 'Enter') {
                this.handleLoginGuest()
            }
        })


    },
    methods: {
        routeToGuestPage() {
            this.loginMode = "GUEST";
        },

        ...mapActions(["getAccountInfo"]),

        async handleLoginGuest() {
            this.isLoggingIn = true;
            const origin = window.location.origin;
            const formData = {
                password: this.data.password.trim(),
            };

            const configDomain = this.$configZimbra.VIRTUAL_HOST.find(el => origin.indexOf(el.origin) !== -1);
            let suffixesDomain = "";
            if (configDomain) {
                formData["virtualHost"] = configDomain.origin;
                suffixesDomain = configDomain.domain;
            }
            if(window.location.hostname.includes('10.208.161.117')){
                if(this.data.username.indexOf("@") > -1 && !this.data?.username.includes('_new')){
                    formData["username"] = `${this.data.username.split("@")[0].trim()}_new${suffixesDomain}`
                }else if(this.data.username.indexOf("_new@") > -1 ) {
                    formData["username"] = `${this.data.username.split("@")[0].trim()}${suffixesDomain}`
                }else if(this.data.username.indexOf("_new") > -1){
                    formData["username"] = `${this.data.username.trim()}${suffixesDomain}`
                } else {
                    formData["username"] = `${this.data.username}_new${suffixesDomain}`;
                }
            }else {
                formData["username"] = this.data.username.indexOf("@") > -1 ? this.data.username : this.data.username.concat(suffixesDomain);
                formData["username"] = formData["username"]?.trim();
            }
            await AccountService.login(formData)
                .then(async (response) => {
                    const { authToken, lifetime, session } = this.getResponseBody(response)["AuthResponse"];

                    const tokenStorage = {
                        lifetime: lifetime,
                        session: session,
                        auth_token: authToken,
                        username :  formData["username"]
                    };
                    this.addLocalStorageObject("zimbra_token", tokenStorage);
                    this.setCookie("login_sc", 1);
                    this.setCookie("ZM_AUTH_TOKEN", authToken);

                })
                .then(() => {
                    const { origin } = window.location;
                    window.location.href = `${origin}/mail`;
                })
                .catch((err) => {
                    const statusCode = err.response ? err.response.status : null;
                    if (statusCode === 301 || statusCode === 302) {
                        window.location.href = err.response.redirectURL;
                    }
                    const errorCode = this.getResponseBody(err.response)[
                        "soap:Fault"
                    ].detail.Error.Code;
                    if (errorCode === ERROR_CODE.ACCOUNT_AUTH_FAILED) {
                        this.authFailed = true;
                    }
                });

            this.isLoggingIn = false;
        },

        hiddenError() {
            this.authFailed = false;
        },
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        handleFocus() {
            this.isUserFocused = true;
        },
        handleBlur() {
            if (this.data.username.length === 0) {
                this.isUserFocused = false;
            }
        },
        handlePassWordFocus() {
            this.isPassFocused = true;
        },
        handlePassWordBlur() {
            if (this.data.password.length === 0) {
                this.isPassFocused = false;
            }
        },

    },
};
</script>
